// web/src/marketing/LandingPage.tsx
//
// Header + PublicFooter come from MarketingLayout (the parent layout
// route). This component is just the body of "/".
import { Hero } from "./sections/Hero";
import { Features } from "./sections/Features";
import { PricingTeaser } from "./sections/PricingTeaser";
import { MagnetPlaceholder } from "./sections/MagnetPlaceholder";
import { Seo } from "./Seo";

export function LandingPage() {
  return (
    <>
      <Seo
        title="Tapelens — News intelligence for active traders"
        description="Real-time news event detection, AI-powered analysis with citations, and sentiment scoring across two instruments side by side. Start free, no card required."
        path="/"
      />
      <main>
        <Hero />
        <Features />
        <PricingTeaser />
        <MagnetPlaceholder />
      </main>
    </>
  );
}
